import React, { useState } from 'react';
import ProjectCard from './ProjectCard';
import ProjectModal from './ProjectModal';
import gameJamProjects from '../data/gameJamProjects';

export default function GameJamList() {
	const [selected, setSelected] = useState(null);

	return (
		<section id="game-jams" className="max-w-8xl px-4 py-2">
			<div className="bg-black/90 rounded-xl overflow-hidden border border-red-400/30 shadow-lg shadow-black/40">
				<div className="px-6 py-5">
					<h2 className="text-4xl font-bold text-white tracking-tight pl-2">Game Jams</h2>
					<hr className="mt-2 border-t-2 border-red-400 w-[13rem]" />
					<p className="text-gray-400 text-base italic mt-3">Short games made within a time limit. Released on Itch.</p>

					<div className="bg-gray-800/20 border border-red-400/20 rounded-lg p-4 sm:p-6 mt-6">
						<div
							className="grid gap-4 justify-start"
							style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 480px))' }}
						>
							{gameJamProjects.map((project, index) => (
								<ProjectCard
									key={index}
									project={project}
									onClick={() => setSelected(project)}
								/>
							))}
						</div>
					</div>
				</div>
			</div>

			{selected && (<ProjectModal project={selected} onClose={() => setSelected(null)} isOpen={true} />)}
		</section>
	);
}